<template>
  <div>
    <v-row>
      <v-col cols="4" offset="8" class="text-right">
        <v-text-field
          v-model="search"
          width="150"
          append-icon="mdi-magnify"
          dense
          rounded
          outlined
          hide-details
          placeholder="Search"
        ></v-text-field>
      </v-col>
      <v-col cols="8" md="3">
        <v-autocomplete
          v-model="selectedPlatforms"
          :items="platformItems"
          outlined
          dense
          chips
          small-chips
          label="Platform"
          multiple
          item-text="text"
          item-value="text"
          @change="handlePlatformFilterChange"
        ></v-autocomplete>
      </v-col>
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="users"
          :search="search"
          :items-per-page="8"
          @click:row="handleClick"
          class="cursor-pointer"
          item-key="id"
        >
          <template v-slot:item.avatar="{ item }">
            <UserAvatar
              :key="`avatar${item.email}`"
              :usersInitials="item.firstName[0] + item.lastName[0]"
              :displayImageUrl="item.displayImageUrl || ''"
            />
          </template>
          <template v-slot:item.isOnBoardedOnApp="{ item }">
            <div>{{ item.isOnBoardedOnApp ? "Yes" : "No" }}</div>
          </template>
          <template v-slot:item.noOfBusinessProfiles="{ item }">
            <div>{{ getNoOfBusinessProfiles(item.email) }}</div>
          </template>
          <template v-slot:item.platform="{ item }">
            {{ getPlatform(item) }}
          </template>
          <!-- <template v-slot:item.lastLoggedInPlatform="{ item }">
            {{
              item.lastLoggedInPlatform
                ? formatLastLoggedInPlatform(item.lastLoggedInPlatform)
                : "-"
            }}
          </template> -->
          <template v-slot:item.signupType="{ item }">
            {{ getSignupType(item) }}
          </template>

          <template v-slot:item.activePlatforms="{ item }">
            <div class="d-flex justify-space-around">
              <v-icon
                size="22"
                class="mr-2"
                :color="
                  item.hasLoggedInToAndroid ? 'primary' : 'grey lighten-1'
                "
                >mdi-android</v-icon
              >
              <v-icon
                size="22"
                :color="item.hasLoggedInToIos ? 'primary' : 'grey lighten-1'"
                class="mr-2"
                >mdi-apple</v-icon
              >
              <v-icon
                size="22"
                :color="item.hasLoggedInToWeb ? 'primary' : 'grey lighten-1'"
                class="mr-2"
                >mdi-xml</v-icon
              >
              <v-icon
                size="22"
                :color="
                  item.hasLoggedInToBusinessPortal
                    ? 'primary'
                    : 'grey lighten-1'
                "
                >mdi-briefcase</v-icon
              >
            </div>
          </template>

          <template v-slot:item.actions="{ item }">
            <v-menu transition="slide-y-transition" bottom left offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on">
                  <v-icon>more_vert</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="handleEditUser(item)">
                  <v-list-item-title>Edit</v-list-item-title>
                </v-list-item>
                <v-list-item @click="handleSendResetPasswordEmail(item)">
                  <v-list-item-title
                    >Send reset password email</v-list-item-title
                  >
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <AppAccountDetails
      v-if="user != null"
      :show="showDialog"
      :cardholders="cardholders"
      :businessPortalAccess="businessPortalAccess"
      :users="allUsers"
      :uid="user.id"
      @close="showDialog = false"
    />

    <v-dialog
      v-model="showEditUserProfileDialog"
      max-width="500"
      persistent
      eager
      v-if="selectedUser"
    >
      <v-card :loading="loading">
        <v-card-title class="justify-space-between">
          Edit User Profile
          <v-btn fab text small @click="showEditUserProfileDialog = false"
            ><v-icon class="text-right text--secondary">close</v-icon></v-btn
          >
        </v-card-title>
        <v-card-text class="py-0">
          <!-- <v-alert
            dense
            text
            prominent
            color="primary"
            v-if="editUserProfileServerError != ''"
          >
            <v-row align="center">
              <v-col class="grow">{{ editUserProfileServerError }}</v-col>
            </v-row>
          </v-alert> -->
          <v-form ref="editUserProfileForm" v-model="isUserProfileFormValid">
            <v-container>
              <v-row>
                <v-col class="pt-0">
                  <v-text-field
                    validate-on-blur
                    :readonly="loading"
                    :rules="nameRules"
                    label="First Name"
                    required
                    outlined
                    dense
                    v-model="firstName"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="pt-0">
                  <v-text-field
                    validate-on-blur
                    :readonly="loading"
                    :rules="nameRules"
                    label="Last Name"
                    required
                    outlined
                    dense
                    v-model="lastName"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="pt-0">
                  <v-text-field
                    :readonly="loading"
                    validate-on-blur
                    :rules="emailRules"
                    label="Email"
                    required
                    outlined
                    dense
                    v-model="email"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="pt-0">
                  <v-btn
                    large
                    elevation="0"
                    color="primary"
                    block
                    :disabled="isSaveDisabled"
                    @click="handleSave"
                  >
                    Save
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>

    <LoadingDialog
      :show="showLoadingDialog"
      title="Sending password reset email..."
    />
  </div>
</template>

<script>
import UserAvatar from "@/components/UserAvatar";
import IconContainer from "@/components/IconContainer";
import AppAccountDetails from "@/components/SuperUser/AppAccountDetails";
import constants from "@/shared/constants";
import { mapActions } from "vuex";
import LoadingDialog from "@/components/LoadingDialog";
import {getHttpsCallable, updateUserDoc} from "@/shared/firebase_utils";

export default {
  components: {
    UserAvatar,
    IconContainer,
    AppAccountDetails,
    LoadingDialog,
  },
  props: {
    cardholders: {
      type: Array,
      default: function () {
        return [];
      },
    },
    businessPortalAccess: {
      type: Array,
      default: function () {
        return [];
      },
    },
    allUsers: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },

  data() {
    return {
      headers: [
        {
          text: "First Name",
          align: "left",
          value: "firstName",
        },
        {
          text: "Last Name",
          align: "left",
          value: "lastName",
        },

        {
          text: "Email",
          align: "left",
          value: "email",
        },
        {
          text: "Onboarded on App (Y/N)",
          align: "left",
          value: "isOnBoardedOnApp",
        },
        {
          text: "No. of Business Profiles",
          align: "left",
          value: "noOfBusinessProfiles",
        },
        {
          text: "Platform",
          align: "left",
          value: "platform",
        },
        {
          text: "Signup Type",
          align: "left",
          value: "signupType",
        },
        // {
        //   text: "Last Logged in Platform",
        //   align: "left",
        //   value: "lastLoggedInPlatform",
        // },
        {
          text: "",
          align: "left",
          value: "activePlatforms",
        },
        {
          text: "Actions",
          align: "left",
          value: "actions",
        },
      ],
      user: null,
      showDialog: false,
      tab: 0,
      businessCardHeaders: [
        {
          text: "",
          align: "right",
          value: "avatar",
          sortable: false,
        },
        {
          text: "First Name",
          align: "left",
          value: "firstName",
        },
        {
          text: "Last Name",
          align: "left",
          value: "lastName",
        },
        {
          text: "Email",
          align: "left",
          value: "email",
        },
        {
          text: "Business Name",
          align: "left",
          value: "businessName",
        },
        {
          text: "Job Title",
          align: "left",
          value: "jobTitle",
        },
        {
          text: "Subscription type",
          align: "left",
          value: "subscriptionType",
        },
        {
          text: "Status",
          align: "left",
          value: "status",
        },
      ],
      associatedBusinessProfileHeaders: [
        {
          text: "Business Name",
          align: "left",
          value: "businessName",
        },
        {
          text: "Email",
          align: "left",
          value: "email",
        },
        {
          text: "Privilege Level",
          align: "left",
          value: "privilegeLevel",
        },

        {
          text: "Status",
          align: "left",
          value: "status",
        },
      ],
      search: "",
      showEditUserProfileDialog: false,
      emailRules: [
        (v) => !!v || "Please enter your email",
        (v) => /.+@.+\..+/.test(v) || "Invalid email",
        (v) => this.isEmailAlreadyInUse(v),
      ],
      nameRules: [(v) => !!v || "This field is required"],
      firstName: "",
      lastName: "",
      email: "",
      selectedUser: null,
      loading: false,
      isUserProfileFormValid: false,
      showLoadingDialog: false,
      platformItems: [
        { text: "Android", value: "hasLoggedInToAndroid" },
        { text: "iOS", value: "hasLoggedInToIos" },
        { text: "Web", value: "hasLoggedInToWeb" },
        { text: "Business Portal", value: "hasLoggedInToBusinessPortal" },
      ],
      selectedPlatforms: [],
      users: [],
    };
  },
  created() {
    this.users = this.allUsers;
  },
  computed: {
    businessCards() {
      let businessCards = this.cardholders.filter((cardholder) => {
        return cardholder.uid == this.user.id;
      });
      return businessCards;
    },
    associatedBusinessProfiles() {
      let associatedBusinessProfiles = this.businessPortalAccess.filter(
        (item) => {
          return item.uid == this.user.id;
        }
      );
      return associatedBusinessProfiles;
    },
    isSaveDisabled() {
      console.log("called");
      //Check if form is valid
      if (!this.isUserProfileFormValid) return true;
      else if (this.loading) return true;
      else {
        //Check if some value has been changed in the form
        if (
          this.firstName != this.selectedUser.firstName ||
          this.lastName != this.selectedUser.lastName ||
          this.email != this.selectedUser.email
        )
          return false;
        else return true;

        return false;
      }
    },
  },
  methods: {
    ...mapActions(["showSnackbar"]),
    onBusinessPortalAccessSnapshot(changes) {
      changes.forEach((change) => {
        let data = change.doc.data();
        if (change.type === "added") {
          this.businessPortalAccess.push({
            ...data,
          });
        } else if (change.type == "modified") {
          //Replace the old cardholder object within the cardholder array with the modified object
          this.businessPortalAccess.forEach((item, i) => {
            if (item.businessProfileId == data.businessProfileId) {
              //Remove the old object of the modified cardholder
              this.businessPortalAccess.splice(i, 1);
              //Add the modified cardholder
              this.businessPortalAccess.push({
                ...data,
              });
            }
          });
        } else if (change.type == "removed") {
          //Remove the cardholder object from the cardholder array
          this.businessPortalAccess.forEach((item, i) => {
            if (item.businessProfileId == data.businessProfileId) {
              //Remove the object of the removed cardholder
              this.businessPortalAccess.splice(i, 1);
            }
          });
        }
      });
    },
    getNoOfBusinessProfiles(email) {
      let usersBusinessProfiles = this.businessPortalAccess.filter((item) => {
        return item.email == email;
      });
      return usersBusinessProfiles.length;
    },
    handleClick(user) {
      this.user = user;
      this.showDialog = true;
    },
    getStatusColor(status) {
      if (status) {
        if (status.toLowerCase() == "active") return "green";
        else if (status.toLowerCase() == "pending") return "orange";
        else if (status.toLowerCase() == "declined") return "red";
        else return "red";
      }
    },
    isBusinessUser(userId) {
      let isBusinessUser = this.businessPortalAccess.some((item) => {
        item.uid == userId;
      });
      return isBusinessUser ? "Yes" : "No";
    },
    formatLastLoggedInPlatform(platform) {
      switch (platform) {
        case "ios":
          return "iOS";
        case "android":
          return "Android";
        case "web":
          return "Web";
        case "business-portal":
          return "Business Portal";
        default:
          return "-";
      }
    },
    getPlatform(user) {
      let platform = "";

      //Return - if both values are undefined
      if (
        (user.lastLoginDate == undefined || user.lastLoginDate == "") &&
        (user.lastLoggedInPlatform == undefined ||
          user.lastLoggedInPlatform == "")
      )
        return "-";
      else {
        //Build the platform string
        platform = user.lastLoginDate
          ? user.lastLoginDate.toDate().toLocaleDateString()
          : "";

        //Add 'the' before Business Portal
        if (user.lastLoggedInPlatform == "business-portal")
          platform += " on the ";
        else platform += " on ";

        platform += user.lastLoggedInPlatform
          ? this.formatLastLoggedInPlatform(user.lastLoggedInPlatform)
          : "-";
        return platform;
      }
    },
    getSignupType(user) {
      if (user.signupType != undefined && user.signupType != "") {
        switch (user.signupType) {
          case constants.REGISTRATION_BY_PAID_CARD_SHARED:
          case constants.REGISTRATION_BY_BASIC_CARD_SHARED:
            return "Connection Request";
          case constants.REGISTRATION_BY_MULTI_CONNECT:
            return "EventConnect";
          case constants.GENERAL_REGISTRATION:
            return "General Registration";
          default:
            return "General Registration";
        }
      } else return "-";
    },
    handleEditUser(user) {
      this.selectedUser = user;

      this.firstName = user.firstName || "";
      this.lastName = user.lastName || "";
      this.email = user.email;

      this.showEditUserProfileDialog = true;
    },
    async handleSave() {
      try {
        //Start: Update the doc in firestore
        await updateUserDoc(this.selectedUser.id, {
          firstName: this.firstName,
          lastName: this.lastName,
          email: this.email,
        });
        //End: Update the doc in firestore

        //Start: If email has been changed, update it in auth
        if (this.email != this.selectedUser.email) {
          this.loading = true;
          const updateEmailByUid = getHttpsCallable("changeEmailByUid");
          let result = await updateEmailByUid({
            email: this.email,
            uid: this.selectedUser.id,
          });
          this.loading = false;
          console.log("result: ", result);
        }
        //End: If email has been changed, update it in auth
        this.showSnackbar({ show: true, text: "Updated succcessfully!" });
      } catch (error) {
        this.showSnackbar({ show: true, text: "Error updating user" });
        console.log("Error occurred while updating user data: ", error);
      }

      this.showEditUserProfileDialog = false;
    },
    isEmailAlreadyInUse(email) {
      if (email != this.selectedUser.email) {
        let isEmailAlreadyInUse = this.users.some(
          (user) => user.email == email
        );
        if (isEmailAlreadyInUse)
          return "Email already exists, please try with a different email address";
        else return true;
      } else return true;
    },
    async handleSendResetPasswordEmail(user) {
      this.showLoadingDialog = true;
      const sendPasswordResetLink = getHttpsCallable("sendResetPasswordEmail");

      let result = await sendPasswordResetLink({
        email: user.email,
        firstName: user.firstName,
      });

      this.showLoadingDialog = false;

      console.log("result: ", result);
    },
    handlePlatformFilterChange() {
      if (this.selectedPlatforms.length > 0) {
        this.users = this.allUsers.filter((user) => {
          return this.selectedPlatforms.every((item) =>
            user.platforms.includes(item)
          );
        });
      } else this.users = this.allUsers;
    },
  },
};
</script>

<style></style>
